import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { QuizProgress } from '../models';

export const quizProgressActions = createActionGroup({
    source: 'Quiz Progress',
    events: {
        'Get Progress': props<{ quizId: string }>(),
        'Get Progress Success': props<{ payload: QuizProgress }>(),
        'Get Progress Not Started': props<{ quizId: string }>(),
        'Get Progress Error': props<{ quizId: string; code: number }>(),

        'Save Answer': props<{ quizId: string; questionId: string; optionId: number }>(),
        'Save Answer Success': props<{ payload: QuizProgress }>(),
        'Save Answer Error': props<{ quizId: string; code: number }>(),

        Retry: props<{ quizId: string }>(),
        'Retry Success': props<{ quizId: string }>(),
        'Retry Error': props<{ quizId: string; code: number }>(),

        Clear: props<{ quizId: string }>(),
        'Clear All': emptyProps(),
    },
});
